export default __webpack_public_path__ + "static/media/1.blur.63b79bdc.jpeg";